import { Box, Typography } from '@mui/material';
import { skipToken } from '@reduxjs/toolkit/query';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Button, LocalModal } from '@/components';
import { selectSessionUserId, useFetchUserProfileQuery } from '@/store';

import { EditProfile } from './EditProfile';

export const UserInfo = () => {
  const userId = useSelector(selectSessionUserId);

  const { data: user } = useFetchUserProfileQuery(
    userId ? undefined : skipToken,
  );

  const [isEditProfileOpen, setisEditProfileOpen] = useState(false);

  return (
    <Box
      sx={{
        borderTop: '1px solid #00000010',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        pt: 1.5,
      }}>
      <Box>
        <Typography variant="h2">
          {user?.firstName} {user?.lastName}
        </Typography>
        <Typography variant="body2">{user?.jobTitle}</Typography>
        <Typography variant="body2">{user?.companyName}</Typography>
      </Box>
      <Button
        variant="secondary"
        label="Edit Profile"
        fullWidth={false}
        sx={styles.button}
        onClick={() => {
          setisEditProfileOpen(true);
        }}
      />
      <LocalModal
        open={isEditProfileOpen}
        onClose={() => setisEditProfileOpen(false)}
        name="Edit Profile">
        <EditProfile
          onSuccess={() => {
            setisEditProfileOpen(false);
          }}
          onCancel={() => {
            setisEditProfileOpen(false);
          }}
        />
      </LocalModal>
    </Box>
  );
};

const styles = {
  button: {
    mt: 1,
    width: 100,
  },
};
